import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Tag, Popover, Spin} from 'antd'
import {withTranslation} from 'react-i18next'

@inject('marketingSmsManagementStore', 'marketingResourcePoolStore', 'accountStore')
@observer
class SearchResult extends Component {
  state = {
  }
  componentDidMount() {
  }
  handlePageChange = (page, pageSize) => {
    const {marketingSmsManagementStore} = this.props
    marketingSmsManagementStore.onChangePersonalPageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {marketingSmsManagementStore, marketingResourcePoolStore} = this.props
    const {isFetchingPhone, pageNoPersonal, pageSizePersonal, itemCountPersonal, excelList, phoneTable} = marketingSmsManagementStore
    const {detailsObj} = marketingResourcePoolStore
    const pagination = getPaginationConfig(pageNoPersonal, pageSizePersonal, itemCountPersonal, this.handlePageChange)
    const TagsList = (tags) => {
      const maxCount = 2; // 最多显示的 Tag 数量
      const remainingCount = tags?.length - maxCount; // 剩余的 Tag 数量
    
      // 如果 Tag 数量超过 maxCount，则截取前 maxCount 个，剩余的用 Tooltip 显示
      const visibleTags = tags?.slice(0, maxCount);
      const content = tags?.map((tag, index) => (
        <Tag color="blue" key={index}>{tag}</Tag>
      ))
      return (
        <div>
          {/* 显示可见的 Tag */}
          {visibleTags?.map((tag, index) => (
            <Tag color="blue" key={index}>{tag}</Tag>
          ))}
    
          {/* 如果有多余的 Tag，显示剩余数量，并用 Tooltip 展示所有隐藏的 Tag */}
          {remainingCount > 0 && (
          <Popover content={content}>
              <Tag color="blue">+{remainingCount}</Tag>
          </Popover>
          )}
        </div>
      );
    };
    return (
      <Spin spinning={isFetchingPhone}>
        <Table 
          className="searchResult" 
          dataSource={toJS(excelList)} 
          pagination={pagination} 
          rowKey="id" 
          rowClassName={this.getRowClassName} 
          style={{marginTop: 0, padding: 0}}
          scroll={{x: 'max-content', scrollToFirstRowOnChange: true}}
        >
          {phoneTable?.map((a, i)=> {
            return (
              <Table.Column title={a?.title} dataIndex={a?.name} key={i} ellipsis={true} render={(text, record) => 
                text && text?.length > 0 ? detailsObj?.conditions?.find(c=>c?.name ===a?.title)?.type==='3' ? TagsList(text?.split("、")) : text : null
              } />
            )
          })}
        </Table>
      </Spin>
    )
  }
}

export default withTranslation()(SearchResult)
